import axios from 'axios'
import config from '@/config'
import $store from '@/store'
import router from '@/router'
import { uuid } from '@/utils'

const { baseURL, ssoURL } = config

Object.assign(axios.defaults, {
  baseURL,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    source: 2
  },
  // withCredentials: true,
  timeout: 10 * 1000 * 60 // 超时时间
})

//请求拦截器
axios.interceptors.request.use(
  cfg => {
    cfg.headers.csrf_token = sessionStorage.getItem('token')
    cfg.headers.authToken = sessionStorage.getItem('authToken')
    cfg.headers.openId = sessionStorage.getItem('OPENID')
    cfg.headers['X-Request-ID'] = uuid() // todo 增加uuid
    // cfg.headers.openId = 'wwb5ed0e862536b4ca_TangShan'

    return cfg
  },
  err => {
    return Promise.reject(err)
  }
)

//请求响应拦截器
axios.interceptors.response.use(
  response => {
    if (tokenExpired(response.data.code)) {
      sessionStorage.removeItem('token')
      router.push('/login')
      return
    } else if (response.status === 200) {
      return response
    }
  },
  error => {
    if (process.env.NODE_ENV === 'production') {
      if (tokenExpired(error.response.status)) {
        localStorage.removeItem('TOKEN')
        router.push('/login')
        return
      }
    }
    return Promise.reject(error)
  }
)
/**
 * 检测登录是否过期
 * @param code
 * @return {boolean}
 */
const tokenExpired = code => [113252, 111253, 113152].includes(code >> 0)

//post请求
export function post(url, params, config) {
  return axios.post(url, params, config)
}
//get请求
export function get(url, params) {
  return axios.get(url, { params: params })
}
//上传
export function upload(url, params) {
  return axios.post(url, params)
}
//post下载文件
export function postDownload(url, params) {
  return axios.post(url, params, { responseType: 'arraybuffer' })
}
